<template>
  <section role="banner" class="partner-banner-section" id="banner">
    <div class="wrapper">
      <div class="banner-content">
        <h1 class="banner-title">
          Pode esquecer, <br />
          a gente te lembra
        </h1>
        <h4 class="banner-text">
          O MeLembre da {{ creditor.name }} é um serviço de comunicação entre
          empresas e pessoas. Facilitamos seu acesso a notificações e faturas,
          assim você mantém sua vida em ordem.
        </h4>
        <v-btn class="banner-button" type="button" @click="router.push('/')">
          Saiba mais
        </v-btn>
      </div>
      <ThePicture
        :mobilePath="`/images/partners/${creditor.alias}/m-banner.png`"
        :tabletPath="`/images/partners/${creditor.alias}/t-banner.png`"
        :desktopPath="`/images/partners/${creditor.alias}/banner.png`"
        mobileQuerie="834px"
        desktopQuerie="960px"
        :altText="`${creditor.name} Banner`"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
const router = useRouter();

const props = defineProps<{
  creditor: CreditorProfile;
}>();
</script>

<style lang="scss"></style>
